// A tour is Active once it has at least one review link with a URL — the same
// rule the backend uses to decide which tours the public tipping pages serve.
// The Status column and the live-preview tour stream must both use this, or
// the preview shows tours a real customer would never see.
export const isTourActive = tour =>
  Boolean(tour?.reviewSites && tour.reviewSites.some(site => site.url && site.url.length));

export const StatusType = {
  incomplete: 'Incomplete',
  active: 'Active'
};

export const StatusBackgroundColor = {
  incomplete: '#555555',
  active: '#d9ffd7'
};

export const StatusForeColor = {
  incomplete: '#eaeaea',
  active: '#12573e'
};

export const ReviewSite = {
  TripAdvisor: 'TripAdvisor',
  Google: 'Google',
  Yelp: 'Yelp',
  Email: 'Email',
  Local: 'Local',
  TrustPilot : 'TrustPilot',
  Feefo : 'Feefo'
};
